





























import { Component, Mixins, Prop } from "vue-property-decorator";
import { DomainRegistry } from "../../../../domain";
import { Dictionary } from "../../../../domain/system";
import {
  ExecuteRequest,
  ExecuteRequestResponse,
} from "../../../../domain/localhost/items";
import { DialogMixin } from "../../../system/mixins";

@Component({
  components: {
  },
})
export default class ApplicationLaunchDialog extends Mixins(DialogMixin) {
  data(): any {
    return {
      result: null as any,
      key: null as string,
      title: "処理中" as string,
      message: "プログラムを実行しています。処理が完了すると自動的に閉じます。",
      timer: null,
      enablePolling: true,
      showButtons: false,
      action: null as string,
    };
  }
  result: any;
  key: string;
  title: string;
  message: string;
  timer: any;
  enablePolling: boolean;
  showButtons: boolean;
  action: string;

  @Prop({ default: false })
  showAdditionalControls: boolean;
  
  mounted() {
    const intervalMilliSeconds = this.$configuration.behavior.document.editor.externalScript.executingDialogPollingIntervalMilliSeconds;
    this.timer = setInterval(() => this.runTimerProcess(), intervalMilliSeconds);
  }

  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  async show(path: string, params: Dictionary<string, string>, additionalInfo: any): Promise<any> {
    // 内部実装で処理可能な場合は即座に結果が出るので、ダイアログの表示は不要
    const resultAsInternalScript = await this.executeAsInternalScript(path, params, additionalInfo);
    if (resultAsInternalScript) { return resultAsInternalScript; }
    
    if (this.isVisible) {
      throw new Error("外部アプリケーションを実行中です。");
    }
    return this.showModal(async () => {
      this.action = params.get("action");
      this.result = null;
      this.key = null;
      this.showButtons = false;

      this.execute(path, params, additionalInfo)
      .then(responce => {
        if (!responce || !responce.key) {
          this.$error("エラー", "外部プロセスのキー情報を取得できませんでした。");
          return;
        }
        this.$logger.debug(responce);
        if (responce.result) {
          this.result = responce.result;
          this.isVisible = false;
        }
        this.key = responce.key;
      })
      .catch(e => {
        this.$error("エラー", "外部プロセスの起動処理でエラーが発生しました。", e);
        this.isVisible = false;
      });
      await this.waitHidden();
      return this.result;
    });
  }

  private async executeAsInternalScript(path: string, params: Dictionary<string, string>, additionalInfo: any): Promise<any> {
    const service = DomainRegistry.localhost.getApplicationService();
    return service.executeAsInternalScript(path, params, additionalInfo);
  }

  execute(path: string, params: Dictionary<string, string>, request: ExecuteRequest): Promise<ExecuteRequestResponse> {
    const service = DomainRegistry.localhost.getApplicationService();
    return service.launchWithKey(path, params, request);
  }

  getResultAndClose(): void {
    if (!this.key) { return; }
    const service = DomainRegistry.localhost.getApplicationService();
    const currentKey = this.key; 
    service.getResult(this.key, this.action)
    .then(result => {
      if (!result || !this.isVisible || !this.key) { return; }
      // 応答のタイミングで他の外部データオブジェクトをクリックされると、
      // そちらに結果が返ってしまうケースが稀に発生するので対策している
      if (currentKey !== this.key) { return; }
      this.result = result;
      this.isVisible = false;
    })
    .catch(e => {
      this.$error("エラー", "結果の取得処理でエラーが発生しました。", e);
    });
  }

  cancel(): void {
    this.key = null;
    this.isVisible = false;
  }

  runTimerProcess(): void {
    if (this.isVisible && this.key && this.enablePolling) {
      this.getResultAndClose();
    }
  }
}
